import Index from '@/components/preview/Index'
export default [
  {
    path: '/tour/:username/:slug',
    name: 'preview',
    component: Index
  }
]



// WEBPACK FOOTER //
// ./src/components/preview/router.js